import { useState, useEffect, useRef } from "react";
import Calendar from "./calendar";
import moment from "moment";
import { useTranslation } from "react-i18next";
import {
    ChevronDown, ChevronUp, Settings, HandCoins, CircleDollarSign,
    Store, Weight, Truck, SlidersHorizontal, X, Check,
} from "lucide-react";
import Select from "react-select";
import { obtenerGeocercas } from "../api/api-grupo-geocerca";
import { obtenerListaTipoCliente } from "../api/api-tipo-cliente";
import { obtenerDetalleSeguimiento } from "../api/api-seguimiento";
import { ASIGNACION_FROM, VERSION_ASIGNACION } from "../page/asignacion/const/version";
import { unirAsignacion } from "../api/api-asignacion";
import { obtenerTodasLasUnidades } from "../api/gestion-dts/gestion";
import { obtenerListaFormulario } from "../api/api-formulario";
import ArrowLeftComponent from "./arrow-left-component";
import { cambiarPlacaPedido } from "../api/api-pedido";
import { obtenerProgressBar } from "../api/api-progress-bar";
import ProgressBarRangeComponent from "./progress-bar-range-component";
// import { ID_EMPRESA } from "../utils/const/empresa-const";
import { STRING_ID_EMPRESA_ULTIMA_MILLA_V3 } from "../utils/const/string-const";
import DetalleProductoModal from "./detalle-producto-modal";
import ModalMontoPagadoAConductor from "./modal-monto-pagado-a-conductor";
import ModalMontoQueDebioSerPagadoAConductor from "./modal-monto-que-debio-ser-pagado-a-conductor";
import EntradaSalidaGeocercaModal from "./entrada-salida-geocerca-modal";
import DividirProductosModal from "./dividir-productos-modal";
import { actualizarWorkflowEnServer } from "../api/api-workflow";
import { obtenerListaUsuarioMovil } from "../api/api-usuario-movil";
import BtnRequestComponent from "./btn-request";
import { cambiarFechaEntregaPedido } from "../api/api-pedido";

/**
 * Sidebar component for seguimiento page
 * Displays a calendar and a list of items
 * 
 * @param {Array} items - Array of items to display
 * @param {Function} onDateChange - Callback when date changes, receives (date) => void
 * @param {Function} onItemClick - Callback when an item is clicked, receives (item) => void
 * @param {Boolean} detailPanelVisible - Whether the detail panel is visible
 */
export default function SidebarSeguimiento({
    items = [],
    onDateChange,
    onItemClick,
    selectedDate,
    detailPanelVisible = false,
    onGeocercasChange,
    onTipoClientesChange,
    showToast,
    setProcessingVisible,
    setSidebarVisible,
    btnConfiguracionPlaca = false,
    btnFiltros = false,
}) {
    const { t } = useTranslation();
    // const contentRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [displayItems, setDisplayItems] = useState(items);
    const [itemsToFilters, setItemsToFilters] = useState(items);
    const [expandedByItem, setExpandedByItem] = useState({});
    const [listaGeocercas, setListaGeocercas] = useState([]);
    const [listaTipoClientes, setListaTipoClientes] = useState([]);
    // Per-item selections (keyed by item.id) so each item has independent geocerca and tipo-cliente selects
    const [selectedGeocercasByItem, setSelectedGeocercasByItem] = useState({});
    const [selectedTipoClientesByItem, setSelectedTipoClientesByItem] = useState({});
    const [settingsDropdownOpen, setSettingsDropdownOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const settingsDropdownRef = useRef(null);
    const settingsButtonRef = useRef(null);
    const filtersButtonRef = useRef(null);
    const [filtersVisible, setFiltersVisible] = useState(false);

    const [modalVisible, setModalVisible] = useState(false);

    const [vehiculoSelectedForFilters, setVehiculoSelectedForFilters] = useState(null);


    const [listaVehiculos, setListaVehiculos] = useState([]);
    const [vehiculoSelected, setVehiculoSelected] = useState(null);

    const [vehiculoSelectedParaCambiarPlaca, setVehiculoSelectedParaCambiarPlaca] = useState(null);
    const [cambiarPlacaModalVisible, setCambiarPlacaModalVisible] = useState(false);
    const [itemParaCambiarPlaca, setItemParaCambiarPlaca] = useState(null);
    const [itemParaCambiarFechaEntrega, setItemParaCambiarFechaEntrega] = useState(null);

    const [fechaSelected, setFechaSelected] = useState(null);
    const [listaFormulario, setListaFormulario] = useState([]);
    const [formularioSelected, setFormularioSelected] = useState(null);

    const [infoProgressBar, setInfoProgressBar] = useState(null);

    const [modalMontoPagadoAConductorModalVisible, setModalMontoPagadoAConductorModalVisible] = useState(false);
    const [itemMontoPagadoAConductor, setItemMontoPagadoAConductor] = useState(null);

    const [modalMontoQueDebioSerPagadoAConductorModalVisible, setModalMontoQueDebioSerPagadoAConductorModalVisible] = useState(false);
    const [itemMontoQueDebioSerPagadoAConductor, setItemMontoQueDebioSerPagadoAConductor] = useState(null);

    const [detalleProductoModalVisible, setDetalleProductoModalVisible] = useState(false);
    const [listaProductoSelected, setListaProductoSelected] = useState([]);

    const idEmpresa = localStorage.getItem(STRING_ID_EMPRESA_ULTIMA_MILLA_V3);

    const [entradaSalidaGeocercaModalVisible, setEntradaSalidaGeocercaModalVisible] = useState(false);
    const [dataModalVisitaGeocerca, setDataModalVisitaGeocerca] = useState(null);

    const [indexListaPedidosSelected, setIndexListaPedidosSelected] = useState(null);

    const [dividirProductosModalVisible, setDividirProductosModalVisible] = useState(false);
    const [productosParaDividir, setProductosParaDividir] = useState(null);

    const [searchFilter, setSearchFilter] = useState("");

    const [cambiarFechaEntregaModalVisible, setCambiarFechaEntregaModalVisible] = useState(false);
    const [sendRequest, setSendRequest] = useState(false);

    useEffect(() => {
        obtenerDatosVehiculos();
        obtenerInfoProgressBar();
        obtenerDatosFormulario();
    }, []);

    const obtenerDatosVehiculos = async () => {
        let unidades = await obtenerTodasLasUnidades();
        // console.log('unidades');
        // console.log(unidades);
        const listaUsuariosMobile = await obtenerListaUsuarioMovil({ habilitado: 1 }, false, t);
        // console.log('listaUsuariosMobile');
        // console.log(listaUsuariosMobile);
        if (Array.isArray(listaUsuariosMobile) && Array.isArray(listaUsuariosMobile)) {
            for (let i = 0; i < unidades.length; i++) {
                const usuarioMobile = unidades[i];
                // console.log('usuarioMobile');
                // console.log(usuarioMobile);
                const info = listaUsuariosMobile.find(e => e.valuePlaca === usuarioMobile.value);
                // console.log('info');
                // console.log(info);
                if (info !== undefined) {
                    unidades[i].peso = info.peso;
                    unidades[i].volumen = info.volumen;
                }
            }
        }
        setListaVehiculos(unidades);
    };

    const obtenerDatosFormulario = async () => {
        const formularios = await obtenerListaFormulario({}, true, t);
        // console.log('formularios');
        // console.log(formularios);
        setListaFormulario(formularios);
    };

    const obtenerInfoProgressBar = async () => {
        const infoProgressBar = await obtenerProgressBar();
        setInfoProgressBar(infoProgressBar);
    };

    // Update displayItems when items prop changes
    useEffect(() => {
        setDisplayItems(items);
    }, [items]);

    // Reset expanded state when detailPanelVisible changes to false
    useEffect(() => {
        if (!detailPanelVisible) {
            setExpandedByItem({});
        }
        if (detailPanelVisible === true) {
            obtenerDatos();
        }
    }, [detailPanelVisible]);

    // Close settings dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                settingsDropdownRef.current &&
                settingsButtonRef.current &&
                !settingsDropdownRef.current.contains(event.target) &&
                !settingsButtonRef.current.contains(event.target)
            ) {
                setSettingsDropdownOpen(false);
            }
        };

        if (settingsDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [settingsDropdownOpen]);

    // Call obtenerDatosParaUnir when modal becomes visible
    // useEffect(() => {
    //     if (modalVisible) {
    //         obtenerDatosParaUnir();
    //     }
    // }, [modalVisible]);


    const obtenerDatos = async () => {
        const listaGeocercas = await obtenerGeocercas();
        setListaGeocercas(listaGeocercas.body);
        const listaTipoClientes = await obtenerListaTipoCliente({ habilitado: 1 }, true);
        setListaTipoClientes(listaTipoClientes);
    };

    // const obtenerDatosParaUnir = async () => {

    // };

    const handleDateChange = (date) => {
        // console.log('handleDateChange', date);
        if (onDateChange) {
            onDateChange(date);
        }
    };

    const handleItemClick = (item) => {
        // console.log('handleItemClick');
        // console.log(item);
        if (onItemClick) {
            onItemClick(item);
        }
    };

    const handleCheckboxChange = (itemId, event) => {
        event.stopPropagation(); // Prevent triggering the item click
        setSelectedItems(prev => {
            if (prev.includes(itemId)) {
                return prev.filter(id => id !== itemId);
            } else {
                return [...prev, itemId];
            }
        });
    };

    const handleUnirPedidos = async () => {
        try {
            setSettingsDropdownOpen(false);
            // console.log('handleUnirPedidos');
            // console.log(selectedItems);
            if (selectedItems.length < 2) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_mas_de_un_elemento"));
                }
                return;
            }
            setModalVisible(true);
        } catch (err) {
            console.log('handleUnirPedidos err');
            console.log(err);
        }
    };

    const handleAceptarModalClick = async () => {
        try {
            if (vehiculoSelected === null || fechaSelected === null || formularioSelected === null) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_vehiculo_fecha_formulario"));
                    return;
                }
                return;
            }
            if (moment(fechaSelected).isValid() === false) {
                if (showToast) {
                    showToast(t("alert_fecha_invalida"));
                    return;
                }
                return;
            }
            setModalVisible(false);
            setProcessingVisible(true);
            const infoPedidos = [];
            for (let i = 0; i < selectedItems.length; i++) {
                const idPedido = selectedItems[i];
                const data = await obtenerDetalleSeguimiento({ idPedido: idPedido });
                // console.log('data');
                // console.log(data);
                infoPedidos.push(data);
            }
            setProcessingVisible(false);
            let idPedidos = [];
            for (let i = 0; i < infoPedidos.length; i++) {
                const data = infoPedidos[i];
                // console.log('data');
                // console.log(data);
                idPedidos.push(data[0].idPedido);
            }
            // console.log('idPedidos');
            // console.log(idPedidos);
            const objEnviar = {
                idPedidos: idPedidos,
                version: VERSION_ASIGNACION,
                from: ASIGNACION_FROM.UNIR,
                valuePlaca: vehiculoSelected.value,
                labelPlaca: vehiculoSelected.label,
                fechaEntrega: fechaSelected,
                idFormulario: formularioSelected.value,
            };
            // console.log('objEnviar');
            // console.log(objEnviar);
            const response = await unirAsignacion(objEnviar);
            // console.log('response');
            // console.log(response);
            if (response.error === false) {
                showToast(t("alert_se_unio_correctamente"));
                window.location.reload();
                return;
            }
            if (response.error === true) {
                showToast(response.message);
            }
        } catch (err) {
            console.log('handleAceptarModalClick err');
            console.log(err);
        }
    };

    const obtenerTotalMontoQueDebioSerPagadoAConductor = (item) => {
        try {
            // console.log('obtenerTotalMontoQueDebioSerPagadoAConductor');
            // console.log(item);
            let monto = 0;
            if (Array.isArray(item.detallePedidosFinalizados)) {
                for (let i = 0; i < item.detallePedidosFinalizados.length; i++) {
                    const detallePedido = item.detallePedidosFinalizados[i];
                    if (Array.isArray(detallePedido.productos)) {
                        for (let j = 0; j < detallePedido.productos.length; j++) {
                            const producto = detallePedido.productos[j];
                            monto += Number(producto?.monto);
                        }
                    }
                }
            }
            monto = monto.toFixed(2);
            return monto;
        } catch (err) {
            console.log('obtenerTotalMontoQueDebioSerPagadoAConductor err');
            console.log(err);
            return null;
        }
    };

    const obtenerTotalMontoPagadoAConductor = (item) => {
        try {
            // console.log('obtenerTotalMontoPagadoAConductor');
            // console.log(item);
            let monto = 0;
            if (Array.isArray(item.estadoPagoInfo)) {
                for (let i = 0; i < item.estadoPagoInfo.length; i++) {
                    const estadoPago = item.estadoPagoInfo[i];
                    if (Array.isArray(estadoPago.detalle)) {
                        for (let j = 0; j < estadoPago.detalle.length; j++) {
                            const detalle = estadoPago.detalle[j];
                            monto += Number(detalle?.monto);
                        }
                    }
                }
            }
            monto = monto.toFixed(2);
            return monto;
        } catch (err) {
            console.log('obtenerTotalMontoPagadoAConductor err');
            console.log(err);
            return null;
        }
    };

    const obtenerMontoTotalProductos = (item) => {
        try {
            // console.log('obtenerMontoTotalProductos');
            // console.log(item);
            let resultado = 0;
            if (Array.isArray(item.productos) === true) {
                for (let i = 0; i < item.productos.length; i++) {
                    const element = item.productos[i];
                    // console.log('element', element);
                    resultado = resultado + Number(element.monto);
                }
                resultado = resultado.toFixed(2);
            }
            // console.log('obtenerMontoTotalProductos resultado', resultado);
            return resultado;
        } catch (err) {
            console.log('obtenerMontoTotalProductos err');
            console.log(err);
            return null;
        }
    };

    const handleShowModalStore = (item) => {
        // console.log('handleShowModalStore');
        // console.log(item);
        setListaProductoSelected(item);
        setDetalleProductoModalVisible(true);
    };

    const handleModificarEstadoPedidoUpdateMontoPago = async (indexDetallePago, monto, indexWorkflow, indexListaPedidos) => {
        try {
            setDisplayItems((prev) => {
                if (
                    !Array.isArray(prev) ||
                    indexListaPedidos == null ||
                    indexWorkflow == null ||
                    indexDetallePago == null
                ) {
                    return prev;
                }
                const next = prev.map((row, i) => {
                    if (i !== indexListaPedidos) return row;
                    if (!Array.isArray(row.estadoPagoInfo)) return row;
                    return {
                        ...row,
                        estadoPagoInfo: row.estadoPagoInfo.map((ep, wi) => {
                            if (wi !== indexWorkflow) return ep;
                            if (!Array.isArray(ep.detalle)) return ep;
                            return {
                                ...ep,
                                detalle: ep.detalle.map((d, di) =>
                                    di === indexDetallePago ? { ...d, monto } : d
                                ),
                            };
                        }),
                    };
                });
                const updatedRow = next[indexListaPedidos];
                if (updatedRow) {
                    queueMicrotask(() => setItemMontoPagadoAConductor(updatedRow));
                }
                return next;
            });
        } catch (error) {
            console.log('handleModificarEstadoPedidoUpdateMontoPago error');
            console.log(error);
        }
    };

    const handleActualiarWorkFlowEnServer = async (indexWorkflow) => {
        try {
            // console.log('handleActualiarWorkFlowEnServer');
            // console.log('indexListaPedidosSelected', indexListaPedidosSelected);
            // console.log('indexWorkflow', indexWorkflow);
            // console.log('displayItems', displayItems);
            const workflow = displayItems[indexListaPedidosSelected].estadoPagoInfo[indexWorkflow];
            // console.log('workflow', workflow);
            let objEnviar = {};
            objEnviar.idWorkflow = workflow.idTuplaWorkflow;
            objEnviar.dynamicFields = workflow.detalle;
            // console.log('objEnviar', objEnviar);
            setProcessingVisible(true);
            const response = await actualizarWorkflowEnServer(objEnviar);
            setProcessingVisible(false);
            if (response.error === false) {
                showToast(t("alert_se_actualizo_correctamente"));
                window.location.reload();
                return;
            } else {
                showToast(response.message);
            }
        } catch (error) {
            console.log('handleActualiarWorkFlowEnServer error');
            console.log(error);
            showToast(error);
        }
    };

    const handlePesoCargaClick = (item) => {
        try {
            console.log('handlePesoCargaClick');
            console.log(item);
            setProductosParaDividir(item.productos);
            setDividirProductosModalVisible(true);
        } catch (error) {
            console.log('handlePesoCargaClick error');
            console.log(error);
            showToast(error);
            return;
        }
    };

    const renderItems = (item, indexListaPedidos) => {
        // console.log('renderItems');
        // console.log(item);
        const isChecked = selectedItems.includes(item.id);
        const isExpanded = !!expandedByItem[item.id];
        const montoTotalProductos = obtenerMontoTotalProductos(item);
        const totalMontoQueDebioSerPagadoAConductor = obtenerTotalMontoQueDebioSerPagadoAConductor(item);
        const totalMontoPagadoAConductor = obtenerTotalMontoPagadoAConductor(item);

        const porcentajeMontoQueDebioSerPagadoAConductor = (totalMontoQueDebioSerPagadoAConductor / montoTotalProductos * 100).toFixed(2);

        const porcentajeMontoPagadoAConductor = (totalMontoPagadoAConductor / montoTotalProductos * 100).toFixed(2);

        const pesoSoportaVehiculo = listaVehiculos.find(e => e.value === item.valuePlaca)?.peso;
        // console.log('pesoSoportaVehiculo');
        // console.log(pesoSoportaVehiculo);

        const pesoCarga = item.pesoTotal;

        return (
            <>
                <div
                    key={item.id || indexListaPedidos}
                    className="p-3 mb-0 bg-gray-50 hover:bg-gray-100 rounded-lg cursor-pointer transition-colors border-l-4"
                    title={t("label_ver_detalle")}
                >
                    <div className="grid grid-cols-2 gap-3 items-center">
                        {/* Column 1 (50%) */}
                        <div className="flex items-center gap-3 min-w-0">
                            <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={(e) => handleCheckboxChange(item.id, e)}
                                onClick={(e) => e.stopPropagation()}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 flex-shrink-0"
                            />
                            <div className="flex flex-col">
                                <span className="truncate"
                                    onClick={() => handleItemClick(item)}
                                >
                                    {item.labelPlaca}
                                </span>
                                {pesoCarga > pesoSoportaVehiculo && (
                                    <div className="flex flex-col">
                                        <div className="flex flex-row cursor-pointer">
                                            <Truck className="h-5 w-5 text-yellow-600" /> <span className="text-sm text-gray-700">{pesoSoportaVehiculo}</span>
                                        </div>
                                        <div className="flex flex-row cursor-pointer"
                                            onClick={() => handlePesoCargaClick(item)}
                                        >
                                            <Weight className="h-5 w-5 text-yellow-600" /> <span className="text-sm text-gray-700"> {pesoCarga}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Column 2 (50%) */}
                        <div className="flex flex-col items-end gap-1">
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleShowModalStore(item.productos);
                                }}
                                className="flex items-center gap-1 text-sm font-semibold text-blue-700 hover:underline"
                                title="Ver detalle de monto"
                            >
                                <Store className="h-5 w-5 text-gray-600" />
                                <span>{montoTotalProductos}</span>
                            </button>
                            <span className="text-sm text-gray-700">
                                {item.totalPedidosFinalizados}/{item.totalPedidos}
                            </span>
                            {/* {
                                (String(idEmpresa).trim() === String(ID_EMPRESA.PLASTICO).trim() ||
                                    String(idEmpresa).trim() === String(ID_EMPRESA.SECOBOL).trim()) && */}
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMontoQueDebioSerPagadoAConductorClick(item);
                                }}
                                className="flex items-center gap-1 text-sm font-semibold text-blue-700 hover:underline"
                                title="Ver detalle de monto"
                            >
                                <CircleDollarSign className="h-5 w-5 text-gray-600" />
                                <span>{totalMontoQueDebioSerPagadoAConductor}{'(' + porcentajeMontoQueDebioSerPagadoAConductor + '%)'}</span>
                            </button>
                            {/* // } */}
                            {/* {
                                    (String(idEmpresa).trim() === String(ID_EMPRESA.PLASTICO).trim() ||
                                        String(idEmpresa).trim() === String(ID_EMPRESA.SECOBOL).trim()) && */}
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleMontoPagadoAConductorClick(item, indexListaPedidos);
                                }}
                                className="flex items-center gap-1 text-sm font-semibold text-blue-700 hover:underline"
                                title="Ver detalle de monto"
                            >
                                <HandCoins className="h-5 w-5 text-gray-600" />
                                <span>{totalMontoPagadoAConductor}{'(' + porcentajeMontoPagadoAConductor + '%)'}</span>
                            </button>
                            {/* // } */}
                        </div>
                    </div>
                </div >
                <ProgressBarRangeComponent
                    percentage={item.porcentajeFinalizado}
                    ranges={infoProgressBar}
                />
                {
                    detailPanelVisible === true && (
                        <div >
                            <button
                                onClick={() => setExpandedByItem((prev) => ({ ...prev, [item.id]: !prev[item.id] }))}
                                className="w-full p-3 flex items-center justify-between bg-gray-50 hover:bg-gray-100 transition-colors"
                            >
                                <span className="text-sm font-medium text-gray-700">
                                    {t("label_opciones_avanzadas")}
                                </span>
                                {isExpanded ? (
                                    <ChevronUp className="h-5 w-5 text-gray-600" />
                                ) : (
                                    <ChevronDown className="h-5 w-5 text-gray-600" />
                                )}
                            </button>
                            {isExpanded && (
                                <div className="p-4 bg-white border-t border-gray-200">
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="geocerca">
                                        {t("label_geocerca")}
                                    </label>
                                    <Select
                                        options={listaGeocercas}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={selectedGeocercasByItem[item.id] ?? null}
                                        onChange={(event) => {
                                            setSelectedGeocercasByItem((prev) => ({ ...prev, [item.id]: event }));
                                            if (onGeocercasChange) onGeocercasChange(event, item);
                                        }}
                                        placeholder={t("placeholder_seleccione_geocercas")}
                                        isMulti={true}
                                    />
                                    <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipo-cliente">
                                        {t("label_tipo_cliente")}
                                    </label>
                                    <Select
                                        options={listaTipoClientes}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={selectedTipoClientesByItem[item.id] ?? null}
                                        onChange={(event) => {
                                            setSelectedTipoClientesByItem((prev) => ({ ...prev, [item.id]: event }));
                                            if (onTipoClientesChange) onTipoClientesChange(event, item);
                                        }}
                                        placeholder={t("placeholder_seleccione_tipo_cliente")}
                                        isMulti={true}
                                    />
                                </div>
                            )}
                        </div>
                    )
                }
                <hr className="my-3 border-gray-200" />

                <ModalMontoPagadoAConductor
                    isOpen={modalMontoPagadoAConductorModalVisible}
                    onClose={() => setModalMontoPagadoAConductorModalVisible(false)}
                    data={itemMontoPagadoAConductor}
                    indexListaPedidos={indexListaPedidosSelected}
                    showToast={showToast}
                    setProcessingVisible={setProcessingVisible}
                    onUpdateMontoPago={handleModificarEstadoPedidoUpdateMontoPago}
                    onActualizarWorkFlowEnServer={handleActualiarWorkFlowEnServer}
                />

                <ModalMontoQueDebioSerPagadoAConductor
                    isOpen={modalMontoQueDebioSerPagadoAConductorModalVisible}
                    onClose={() => setModalMontoQueDebioSerPagadoAConductorModalVisible(false)}
                    data={itemMontoQueDebioSerPagadoAConductor}
                />

                <DetalleProductoModal
                    isOpen={detalleProductoModalVisible}
                    onClose={() => setDetalleProductoModalVisible(false)}
                    data={listaProductoSelected}
                />

                {/* BRAND NEW MODEL */}
            </>
        )
    };

    const handleMontoPagadoAConductorClick = (item, indexListaPedidos) => {
        // console.log('handleMontoPagadoAConductorClick');
        // console.log(item);
        // console.log('indexListaPedidos', indexListaPedidos);
        setItemMontoPagadoAConductor(item);
        setIndexListaPedidosSelected(indexListaPedidos);
        setModalMontoPagadoAConductorModalVisible(true);
    };

    const handleMontoQueDebioSerPagadoAConductorClick = (item) => {
        // console.log('handleMontoQueDebioSerPagadoAConductorClick');
        // console.log('item', item);
        // console.log('indexListaPedidos', indexListaPedidos);
        setItemMontoQueDebioSerPagadoAConductor(item);
        // setIndexListaPedidosSelected(indexListaPedidos);
        setModalMontoQueDebioSerPagadoAConductorModalVisible(true);
    };

    const handleCambiarPlaca = async () => {
        try {
            setSettingsDropdownOpen(false);
            if (selectedItems.length > 1) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_solo_un_elemento"));
                }
                return;
            }
            if (selectedItems.length === 0) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_al_menos_un_elemento") || "Debe seleccionar al menos un elemento");
                }
                return;
            }
            const item = items.find((i) => i.id === selectedItems[0]);
            if (!item) return;
            setItemParaCambiarPlaca(item);
            setVehiculoSelectedParaCambiarPlaca(null);
            setCambiarPlacaModalVisible(true);
        } catch (err) {
            console.log('handleCambiarPlaca err');
            console.log(err);
        }
    };

    const handleCambiarPlacaAccept = async () => {
        try {
            // console.log('handleCambiarPlacaAccept');
            // console.log(itemParaCambiarPlaca);
            // console.log(vehiculoSelectedParaCambiarPlaca);
            const idPedido = itemParaCambiarPlaca.id;
            // console.log('idPedido');
            // console.log(idPedido);
            const objEnviar = {
                listaPedido: [idPedido],
                valuePlaca: vehiculoSelectedParaCambiarPlaca.value,
                labelPlaca: vehiculoSelectedParaCambiarPlaca.label,
            };
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;
            setProcessingVisible(true);
            const response = await cambiarPlacaPedido(objEnviar);
            setProcessingVisible(false);
            if (response.error === false) {
                setCambiarPlacaModalVisible(false);
                setItemParaCambiarPlaca(null);
                setVehiculoSelectedParaCambiarPlaca(null);
                showToast(t("alert_se_cambio_placa_correctamente"));
                await new Promise(resolve => setTimeout(resolve, 1500));
                window.location.reload();
                return;
            }
            if (response.error === true) {
                showToast(response.message);
            }
        } catch (err) {
            console.log('handleCambiarPlacaAccept err');
            console.log(err);
            setProcessingVisible(false);
        }
    };

    const handleCambiarPlacaCancel = () => {
        setCambiarPlacaModalVisible(false);
        setItemParaCambiarPlaca(null);
        setVehiculoSelectedParaCambiarPlaca(null);
    };

    const handleEntradaSalidaGeocerca = () => {
        try {
            setSettingsDropdownOpen(false);
            if (selectedItems.length > 1) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_solo_un_elemento"));
                }
                return;
            }
            if (selectedItems.length === 0) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_al_menos_un_elemento") || "Debe seleccionar al menos un elemento");
                }
                return;
            }
            const item = items.find((i) => i.id === selectedItems[0]);
            if (!item) return;
            // console.log('item', item);
            let objData = {};
            objData.valuePlaca = item.valuePlaca;
            objData.labelPlaca = item.labelPlaca;
            objData.fechaEntrega = item.fechaEntrega;
            objData.idEmpresa = idEmpresa;
            setDataModalVisitaGeocerca(objData);
            setEntradaSalidaGeocercaModalVisible(true);
        } catch (error) {
            console.log('handleEntradaSalidaGeocerca err');
            console.log(error);
        }
    };

    const handleCambiarFechaEntrega = () => {
        try {
            setSettingsDropdownOpen(false);
            if (selectedItems.length > 1) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_solo_un_elemento"));
                }
                return;
            }
            if (selectedItems.length === 0) {
                if (showToast) {
                    showToast(t("alert_debe_seleccionar_al_menos_un_elemento") || "Debe seleccionar al menos un elemento");
                }
                return;
            }
            const item = items.find((i) => i.id === selectedItems[0]);
            if (!item) return;
            console.log('item', item);
            setItemParaCambiarFechaEntrega(item);
            setCambiarFechaEntregaModalVisible(true);
        } catch (error) {
            console.log('handleCambiarFechaEntrega err');
            console.log(error);
        }
    };

    const handleCambiarFechaEntregaAccept = async () => {
        try {
            console.log('handleCambiarFechaEntregaAccept');
            console.log(itemParaCambiarFechaEntrega);
            let objEnviar = {};
            objEnviar.idPedido = itemParaCambiarFechaEntrega.id;
            objEnviar.fechaEntrega = fechaSelected;
            // console.log('objEnviar');
            // console.log(objEnviar);
            setSendRequest(true);
            setProcessingVisible(true);
            const response = await cambiarFechaEntregaPedido(objEnviar);
            setProcessingVisible(false);
            if (response.error === false) {
                showToast(t("alert_se_cambio_fecha_entrega_correctamente"));
                window.location.reload();
                return;
            }
            if (response.error === true) {
                showToast(response.message);
            }
        } catch (error) {
            console.log('handleCambiarFechaEntregaAccept err');
            console.log(error);
        } finally {
            setSendRequest(false);
        }
    };

    useEffect(() => {
        // console.log('searchFilter');
        // console.log(searchFilter);
        // console.log('vehiculoSelectedForFilters');
        // console.log(vehiculoSelectedForFilters);
        // console.log('renderItems');
        // console.log(items);
        let filteredItems = [...itemsToFilters];
        // console.log('filteredItems');
        // console.log(filteredItems);
        if (vehiculoSelectedForFilters !== null) {
            filteredItems = filteredItems.filter(item => item.valuePlaca === vehiculoSelectedForFilters.value);
        }
        if (String(searchFilter).trim().length > 0) {
            const search = searchFilter.toLowerCase().trim();

            filteredItems = filteredItems.filter((item) => {
                const matchNumeroDocumento = item.listaNumeroDocumento?.some((numero) =>
                    numero.toLowerCase().includes(search)
                );

                const matchNombreCliente = item.productos?.some((producto) =>
                    producto.nombreCliente?.toLowerCase().includes(search)
                );

                return matchNumeroDocumento || matchNombreCliente;
            });
        }
        setDisplayItems(filteredItems);
    }, [searchFilter, vehiculoSelectedForFilters]);

    useEffect(() => {
        if (filtersVisible === false) {
            setVehiculoSelectedForFilters(null);
            setSearchFilter("");
        }
    }, [filtersVisible]);

    const render = () => {
        try {
            return (
                <div className="h-full flex flex-col bg-white border-r border-gray-200">
                    {/* Calendar Section */}
                    <div className="p-4 border-b border-gray-200 relative">
                        <div className="flex items-center gap-2 mb-2">
                            <button
                                onClick={() => {
                                    setSidebarVisible(false);
                                }}
                                className="p-1 hover:bg-gray-100 rounded-lg transition-colors relative"
                                title={t("label_ocultar_sidebar")}
                            >
                                <ArrowLeftComponent className="h-4 w-4 text-gray-600 transition-transform hover:scale-110" />
                            </button>
                            <label className="flex-1 text-sm font-medium text-gray-700">
                                {t("label_seleccionar_fecha")}
                            </label>
                            <div>
                                {btnConfiguracionPlaca === true && (
                                    <button
                                        ref={settingsButtonRef}
                                        onClick={() => setSettingsDropdownOpen(!settingsDropdownOpen)}
                                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors relative"
                                        title={t("label_configuracion") || "Configuración"}
                                    >
                                        <Settings className="h-4 w-4 text-gray-600 transition-transform hover:scale-110" />
                                    </button>
                                )}
                                {btnFiltros === true && (
                                    <button
                                        ref={filtersButtonRef}
                                        onClick={() => {
                                            console.log('filtersButtonRef');
                                            setFiltersVisible(!filtersVisible);
                                        }}
                                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors relative"
                                        title={t("label_filtros") || "Filtros"}
                                    >
                                        {filtersVisible ? <X className="h-4 w-4" /> : <SlidersHorizontal className="h-4 w-4" />}
                                    </button>
                                )}
                            </div>
                        </div>
                        <Calendar
                            value={selectedDate || moment().format("YYYY-MM-DD")}
                            onChange={handleDateChange}
                            format="YYYY-MM-DD"
                            className="w-full"
                        />

                        {/* Settings Dropdown Menu */}
                        {settingsDropdownOpen && (
                            <div
                                ref={settingsDropdownRef}
                                className="absolute right-4 top-12 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50"
                            >
                                <div className="py-1">
                                    <button
                                        onClick={handleUnirPedidos}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        {t("label_unir_pedidos")}
                                    </button>
                                    <button
                                        onClick={handleCambiarPlaca}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        {t("label_cambiar_placa")}
                                    </button>
                                    <button
                                        onClick={handleEntradaSalidaGeocerca}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        {t("label_entrada_salida_geocerca")}
                                    </button>
                                    <button
                                        onClick={handleCambiarFechaEntrega}
                                        className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                                    >
                                        {t("label_cambiar_fecha_entrega")}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {filtersVisible && (
                        <div className="p-2 border-b border-gray-200 relative">
                            <>
                                <label className="block text-[#0F3457] font-semibold mb-0" htmlFor="geocerca">
                                    {t("label_lista_vehiculos")}
                                </label>
                                <Select
                                    options={listaVehiculos}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={vehiculoSelectedForFilters}
                                    onChange={(event) => {
                                        setVehiculoSelectedForFilters(event);
                                    }}
                                    placeholder={t("placeholder_seleccione_vehiculo")}
                                    isMulti={false}
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 999 }),
                                        menu: (base) => ({ ...base, zIndex: 999 }),
                                    }}
                                />
                            </>
                            <>
                                <label className="block text-[#0F3457] font-semibold mb-0 mt-2" htmlFor="geocerca">
                                    {t("label_buscar")}
                                </label>
                                <input
                                    type="text"
                                    value={searchFilter}
                                    onChange={(e) => {
                                        const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9,._\- ]/g, "");
                                        setSearchFilter(sanitizedValue)
                                    }}
                                    placeholder={t("placeholder_ingrese_numero_documento")}
                                    className="w-full p-2 border border-gray-300 rounded-md"
                                    maxLength={24}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{(searchFilter || 0).length}/24</p>
                            </>
                        </div>
                    )}
                    {/* Items List Section */}
                    <div className="flex-1 min-h-0 overflow-y-auto">
                        {loading ? (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-gray-500">{t("label_cargando") || "Cargando..."}</div>
                            </div>
                        ) : displayItems.length === 0 ? (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-gray-500 text-center px-4">
                                    {t("label_sin_datos")}
                                </div>
                            </div>
                        ) : (
                            <div className="p-2">
                                {displayItems.map((item, index) => (
                                    renderItems(item, index)
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Modal to display selected items */}
                    {modalVisible && (
                        <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center p-4">
                            <div className="fixed inset-0 bg-gray-500 opacity-75" onClick={() => setModalVisible(false)}></div>
                            <div className="bg-white w-11/12 md:max-w-2xl mx-auto rounded shadow-lg z-50 overflow-hidden flex flex-col max-h-[90vh] min-h-[600px]">
                                {/* Modal Header */}
                                <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {t("label_items_seleccionados")}: ({selectedItems.length})
                                    </h3>
                                    <button
                                        onClick={() => setModalVisible(false)}
                                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                                        aria-label={t("label_cerrar") || "Cerrar"}
                                    >
                                        <X className="h-5 w-5 text-gray-600" />
                                    </button>
                                </div>
                                <div className="px-6 py-4 border-b border-gray-200">
                                    <div className="grid grid-cols-12 gap-4">
                                        <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_vehiculo")}</label>
                                            <Select
                                                options={listaVehiculos}
                                                value={vehiculoSelected}
                                                onChange={(option) => setVehiculoSelected(option)}
                                                placeholder={t("placeholder_seleccione_vehiculo")}
                                                isClearable={true}
                                                isSearchable={true}
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                        <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_fecha_entrega")}</label>
                                            <Calendar
                                                value={fechaSelected}
                                                onChange={(date) => setFechaSelected(date)}
                                                placeholder={t("placeholder_seleccione_fecha")}
                                                id="fecha_asignacion"
                                                name="fecha_asignacion"
                                            />
                                        </div>
                                        <div className="col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                            <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_formulario")}</label>
                                            <Select
                                                options={listaFormulario}
                                                value={formularioSelected}
                                                onChange={(option) => setFormularioSelected(option)}
                                                placeholder={t("placeholder_seleccione_formulario")}
                                                isClearable={true}
                                                isSearchable={true}
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="px-6 py-4 border-b border-gray-200 h-[400px]">

                                </div>
                                {/* Modal Footer */}
                                <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
                                    <button
                                        onClick={() => setModalVisible(false)}
                                        className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-gray-500 transition-colors"
                                    >
                                        <X className="h-4 w-4 transition-transform hover:scale-110" />
                                        {t("label_cerrar")}
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleAceptarModalClick();
                                        }}
                                        className="inline-flex items-center justify-center gap-2 px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500 transition-colors"
                                    >
                                        <Check className="h-4 w-4 transition-transform hover:scale-110" />
                                        {t("label_aceptar")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Modal Cambiar Placa: select vehicle, Accept / Cancel, close icon */}
                    {cambiarPlacaModalVisible && (
                        <div className="fixed z-[60] inset-0 flex items-center justify-center p-4">
                            <div className="absolute inset-0 bg-black/40" onClick={handleCambiarPlacaCancel} aria-hidden="true" />
                            <div className="relative bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md flex flex-col">
                                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {t("label_cambiar_placa") || "Cambiar placa"}
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={handleCambiarPlacaCancel}
                                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                                        aria-label={t("label_cerrar") || "Cerrar"}
                                    >
                                        <X className="h-5 w-5 text-gray-600" />
                                    </button>
                                </div>
                                <div className="p-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        {t("label_vehiculo")}
                                    </label>
                                    <Select
                                        options={listaVehiculos}
                                        value={vehiculoSelectedParaCambiarPlaca}
                                        onChange={(option) => setVehiculoSelectedParaCambiarPlaca(option)}
                                        placeholder={t("placeholder_seleccione_vehiculo")}
                                        isClearable
                                        isSearchable
                                        classNamePrefix="react-select"
                                    />
                                </div>
                                <div className="px-4 py-3 border-t border-gray-200 flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={handleCambiarPlacaCancel}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                                    >
                                        {t("label_cancelar") || "Cancelar"}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleCambiarPlacaAccept}
                                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors inline-flex items-center gap-2"
                                    >
                                        <Check className="h-4 w-4" />
                                        {t("label_aceptar")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {entradaSalidaGeocercaModalVisible && (
                        <EntradaSalidaGeocercaModal
                            isOpen={entradaSalidaGeocercaModalVisible}
                            onClose={() => setEntradaSalidaGeocercaModalVisible(false)}
                            data={dataModalVisitaGeocerca}
                        />
                    )}

                    {dividirProductosModalVisible && (
                        <DividirProductosModal
                            isOpen={dividirProductosModalVisible}
                            onClose={() => setDividirProductosModalVisible(false)}
                            data={productosParaDividir}

                            listaVehiculos={listaVehiculos}

                            vehiculoSelected={vehiculoSelected}
                            setVehiculoSelected={setVehiculoSelected}

                            setFechaSelected={setFechaSelected}
                            fechaSelected={fechaSelected}

                            listaFormulario={listaFormulario}
                            formularioSelected={formularioSelected}
                            setFormularioSelected={setFormularioSelected}
                            showToast={showToast}
                            setProcessingVisible={setProcessingVisible}
                        />
                    )}

                    {/* Modal Cambiar Placa: select vehicle, Accept / Cancel, close icon */}
                    {cambiarFechaEntregaModalVisible && (
                        <div className="fixed z-[60] inset-0 flex items-center justify-center p-4">
                            <div className="absolute inset-0 bg-black/40" onClick={() => setCambiarFechaEntregaModalVisible(false)} aria-hidden="true" />
                            <div className="relative bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-md flex flex-col">
                                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {t("label_cambiar_fecha_entrega")}
                                    </h3>
                                    <button
                                        type="button"
                                        onClick={() => setCambiarFechaEntregaModalVisible(false)}
                                        className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
                                        aria-label={t("label_cerrar")}
                                    >
                                        <X className="h-5 w-5 text-gray-600" />
                                    </button>
                                </div>
                                <div className="p-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_fecha_entrega")}</label>
                                    <Calendar
                                        value={fechaSelected}
                                        onChange={(date) => setFechaSelected(date)}
                                        placeholder={t("placeholder_seleccione_fecha")}
                                        id="fecha_entrega"
                                        name="fecha_entrega"
                                    />
                                </div>
                                <div className="px-4 py-3 border-t border-gray-200 flex justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={() => setCambiarFechaEntregaModalVisible(false)}
                                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
                                    >
                                        {t("label_cancelar") || "Cancelar"}
                                    </button>
                                    {sendRequest === false &&
                                        <button
                                            type="button"
                                            onClick={handleCambiarFechaEntregaAccept}
                                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md transition-colors inline-flex items-center gap-2"
                                        >
                                            <Check className="h-4 w-4" />
                                            {t("label_aceptar")}
                                        </button>
                                    }
                                    {sendRequest === true &&
                                        <BtnRequestComponent label={t("label_aceptar")} />
                                    }
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            );
        } catch (error) {
            console.log('render err');
            console.log(error);
            return null;
        }
    };

    return render();
}

